var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackOfficeTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 10.4166V14.5833M2.70834 4.16663H9.14376C9.29273 4.16661 9.4368 4.21981 9.55001 4.31663L12.8458 7.14163C12.9591 7.23844 13.1031 7.29164 13.2521 7.29163H22.2917C22.3738 7.29163 22.455 7.30779 22.5309 7.3392C22.6067 7.37061 22.6756 7.41665 22.7336 7.47468C22.7917 7.53272 22.8377 7.60162 22.8691 7.67745C22.9005 7.75328 22.9167 7.83455 22.9167 7.91663V10.8333C22.9167 10.9154 22.9005 10.9966 22.8691 11.0725C22.8377 11.1483 22.7917 11.2172 22.7336 11.2752C22.6756 11.3333 22.6067 11.3793 22.5309 11.4107C22.455 11.4421 22.3738 11.4583 22.2917 11.4583H2.70834C2.54258 11.4583 2.38361 11.3924 2.2664 11.2752C2.14919 11.158 2.08334 10.9991 2.08334 10.8333V4.79163C2.08334 4.62587 2.14919 4.46689 2.2664 4.34968C2.38361 4.23247 2.54258 4.16663 2.70834 4.16663Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08334 10.4166V20.2083C2.08334 20.3741 2.14919 20.533 2.2664 20.6502C2.38361 20.7674 2.54258 20.8333 2.70834 20.8333H13.5417M19.7917 21.875C20.3442 21.875 20.8741 21.6555 21.2648 21.2648C21.6555 20.8741 21.875 20.3442 21.875 19.7916C21.875 19.2391 21.6555 18.7092 21.2648 18.3185C20.8741 17.9278 20.3442 17.7083 19.7917 17.7083C19.2391 17.7083 18.7092 17.9278 18.3185 18.3185C17.9278 18.7092 17.7083 19.2391 17.7083 19.7916C17.7083 20.3442 17.9278 20.8741 18.3185 21.2648C18.7092 21.6555 19.2391 21.875 19.7917 21.875Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 22.9166C20.6205 22.9166 21.4153 22.5874 22.0014 22.0013C22.5874 21.4153 22.9167 20.6204 22.9167 19.7916C22.9167 18.9628 22.5874 18.168 22.0014 17.5819C21.4153 16.9959 20.6205 16.6666 19.7917 16.6666C18.9629 16.6666 18.168 16.9959 17.582 17.5819C16.9959 18.168 16.6667 18.9628 16.6667 19.7916C16.6667 20.6204 16.9959 21.4153 17.582 22.0013C18.168 22.5874 18.9629 22.9166 19.7917 22.9166Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.31 2.08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOfficeTray);
export default __webpack_public_path__ + "static/media/Back Office Tray.9b98cb7f2c5036685d154d54d1212b1f.svg";
export { ForwardRef as ReactComponent };